import React, { useState } from "react";

export default function SeoCollapse({ children, previewHeight = 175 }) {
    const [expanded, setExpanded] = useState(false);

    return (
        <>
            <div
                className={`overflow-hidden position-relative`}
                style={{
                    maxHeight: expanded ? "none" : previewHeight,
                    transition: "max-height 0.4s ease"
                }}
            >
                {children}

                {!expanded && (
                    <div
                        className="position-absolute bottom-0 start-0 w-100"
                        style={{
                            height: "60px",
                            background: "linear-gradient(to bottom, rgba(255,255,255,0), #fff)"
                        }}
                    />
                )}
            </div>
            <div className="text-center">
                <button
                    className="btn btn-link text-secondary fw-semibold p-0 mb-2"
                    type="button"
                    onClick={() => setExpanded(!expanded)}
                >
                    {expanded ? "Показати менше" : " Показати більше"}
                </button>
            </div>
        </>
    );
}
